module.exports = __webpack_public_path__ + "static/media/ctf.21a7da40.png";